import { render, staticRenderFns } from "./doctel-connection.vue?vue&type=template&id=1a8c06b6&scoped=true&"
import script from "./doctel-connection.vue?vue&type=script&lang=js&"
export * from "./doctel-connection.vue?vue&type=script&lang=js&"
import style0 from "./doctel-connection.vue?vue&type=style&index=0&id=1a8c06b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8c06b6",
  null
  
)

export default component.exports